import React from 'react';
import SectionLabel from '../common/SectionLabel';
import { servicePlaces, studioAnswers } from '../../data/locations';

const WhereWeWork = () => {
  return (
    <section id="where-we-work" className="relative bg-black">
      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-3xl">
          <SectionLabel>Locations</SectionLabel>
          <h2 className="mt-6 text-4xl text-white md:text-5xl">Where we work</h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#d0d0d0] md:text-base">
            ThirtyFive Studio is based in Rochester, MN. We handle web development, branding, app
            development, and more. We meet you at your business across the Twin Cities and southeast
            Minnesota, and we also work remotely.
          </p>
        </div>
        <ul className="mt-10 flex flex-wrap gap-3">
          {servicePlaces.map((place) => (
            <li key={place.name}>
              {place.slug ? (
                <a
                  href={`/locations/${place.slug}`}
                  className="inline-flex border border-white/15 px-4 py-2 text-sm text-white hover:border-white/40"
                >
                  {place.name}
                </a>
              ) : place.name === 'and more' ? (
                <span className="inline-flex px-1 py-2 text-sm text-[#d0d0d0]">and more</span>
              ) : (
                <span className="inline-flex border border-white/10 px-4 py-2 text-sm text-[#d0d0d0]">
                  {place.name}
                </span>
              )}
            </li>
          ))}
        </ul>
        <div className="mt-16 max-w-3xl space-y-8 border-t border-white/10 pt-10">
          {studioAnswers.map((item) => (
            <div key={item.question}>
              <h3 className="text-2xl text-white">{item.question}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#d0d0d0] md:text-base">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhereWeWork;
